import { FC, ReactElement } from 'react'

import './LoadingScreen.scss'

interface LoadingScreenProps {
    className?: string
}

export const LoadingScreen: FC<LoadingScreenProps> = ({ className = '' }): ReactElement => (
    <div className={`loading-screen ${className}`}>
        <div className="loading-screen__loader" />
    </div>
)
